import { useEffect, useState } from 'react';

// Forces a re-render every `intervalMs` so time-derived UI stays current.
export const useTick = (intervalMs: number = 30000) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(tick => tick + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
};
